// extracted by mini-css-extract-plugin
export var tocpicsGobackBtn = "bN_f6";
export var topicsFilterContainer = "bN_f4";
export var topicsFilterWrapper = "bN_f5";